import { IQuestion } from '@meeting/models/meeting-question.model';
import { TalentLocale } from '@models/locales';

export function sortMeetingQuestionsByTextLocale(
  locale: TalentLocale,
  qA: IQuestion,
  qB: IQuestion,
) {
  return Intl.Collator(locale).compare(
    qA.textReviewee[locale],
    qB.textReviewee[locale],
  );
}
